export default __webpack_public_path__ + "static/media/roboto-v20-latin-300.865f928c.woff";